<template>
    <v-container fluid pt-0>
      <v-card flat color="background">
        <v-card-title>Gr8table Token</v-card-title>

      <!-- <v-card-text v-if="!token">
          <v-select
          v-model="applicationType"
          style="max-width: 300px;"
          :items="[
            {
              label: 'Budler',
              value: 'budler',
            },{
              label: 'Gr8table',
              value: 'gr8table',
            }
          ]"
          label="Application type"
          item-text="label"
          item-value="value"
        ></v-select>
      </v-card-text> -->

        <v-card-text>
         
            <input type="hidden" :value="cloverVerifyUrl" style="display:none"/>
            <a v-if="!token" href="#" @click.prevent="openCloverWindow" class="v-btn theme--light elevation-0 v-size--default primary">Generate Token</a>

            <v-col v-if="token">Please copy the below code (token) and  add  to your payment processor setting.</v-col>
            <v-alert
            prominent
            type="success"
            class="mt-3"
            v-if="token"
            >
              <v-row align="center">
                <v-col class="grow headline">{{ token }} </v-col>
                <v-col class="shrink">
                  <v-btn color="primary" @click="copytext">COPY</v-btn>
                </v-col>
              </v-row>
            </v-alert>
        </v-card-text>
      </v-card>
    </v-container>
  </template>

  <script>
  /* eslint-disable */
  import { LocationAPI } from '@/clients/locations/locations.api'
  import {clover_url, clover_great_table_client_id, clover_great_table_redirect_url} from "@/global"
  import { mapGetters, mapActions, mapMutations } from 'vuex'

  export default {
    mounted() {
      this.vm_cloverDetails({
        clover_token: '', 
      })
    },
    data() {
      return {
        cloverWindow: '',
        token: '',
        applicationType: 'gr8table',
      }
    },

    computed: {
        cloverVerifyUrl() {
          // + '/' + (this.vg_selectedLocation.id ? this.vg_selectedLocation.id : this.$route.params.id);          
          let clientId = clover_great_table_client_id;
          let redirectUrl = clover_great_table_redirect_url;
          return `${clover_url}/oauth/authorize?client_id=${clientId}&merchant_id=&redirect_uri=${redirectUrl}`;

        },
        ...mapGetters({
            vg_selectedLocation: 'locations/selectedLocation',
            vg_cloverDetails: 'cloverGr8/details',
        }),
    },
    
    watch: {
        vg_cloverDetails: {
            handler: async function(cloverData) {
              if(cloverData.clover_token) {
                this.token = cloverData.clover_token
              }
            // if(cloverData && cloverData.code){
            //     await this.getCloverAccessToken(cloverData.code);
            //     //this.cloverWindow.close();
            // }
    
            },
            deep:true
        },

    },


    methods: {

    /**
     * 
     * get clover token
     */
      // async getCloverAccessToken(accessKey) {
      //  try{
      //       let res = await LocationAPI.fetchCloverToken(accessKey);
      //       if(res.status == 200) {
      //           this.token = res.data.payload.access_token;
      //       } else {
      //           this.token = '';
      //       }
      //  } catch(err) {
      //       alert('Unable to proceed please try again later.')
      //       console.log(err)
      //       this.token = '';
      //  }
        
      // },

      openCloverWindow() {
        this.cloverWindow = window.open(this.cloverVerifyUrl, "", "width=800,height=500");
      },

      copytext() {
        navigator.clipboard.writeText(this.token);
        this.snackbar({ text: 'Copied!', color: 'success', icon: 'check' })
      },

     
    ...mapMutations({
        vm_cloverDetails: 'cloverGr8/detailsMutate'
    }),
        
     
    }
  }
  </script>
  
  <style lang="scss" scoped>
  </style>
  